import Icon from './Icon';
import { comparisonRows, plans } from '../constants/content';
import { SUPPORT_PHONE_TEL } from '../constants/site';

function Cell({ value }) {
  if (value === true) {
    return (
      <span className="compare__yes">
        <Icon name="check" size={18} strokeWidth={2.8} />
      </span>
    );
  }
  if (value === false) {
    return <span className="compare__no">—</span>;
  }
  return <span>{value}</span>;
}

export default function Comparison() {
  return (
    <section className="section" id="compare">
      <div className="container">
        <div className="sec-head sec-head--center">
          <p className="kicker">Side by Side</p>
          <h2 className="sec-title">McAfee Plan Comparison</h2>
          <p className="sec-lead">
            Not sure which tier fits? Here is exactly what changes as you move up — no fine print,
            no surprises at checkout.
          </p>
        </div>

        <p className="compare__hint">
          <Icon name="arrow" size={16} />
          Swipe the table sideways to see all plans
        </p>

        <div className="compare">
          <div className="compare__scroll">
            <table>
              <caption className="sr-only" style={{ position: 'absolute', left: -9999 }}>
                Feature comparison across McAfee plans
              </caption>
              <thead>
                <tr>
                  <th scope="col">Feature</th>
                  {plans.map((plan) => (
                    <th
                      key={plan.id}
                      scope="col"
                      className={plan.featured ? 'is-featured' : undefined}
                    >
                      {plan.name}
                      <span>${plan.price} / year</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {comparisonRows.map((row) => (
                  <tr key={row.label}>
                    <td>{row.label}</td>
                    {row.values.map((value, i) => (
                      <td key={plans[i].id} className={plans[i].featured ? 'is-featured' : undefined}>
                        <Cell value={value} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="compare__foot">
            {plans.map((plan) => (
              <a
                key={plan.id}
                href={`tel:${SUPPORT_PHONE_TEL}`}
                className={`btn btn--block ${plan.featured ? 'btn--red' : 'btn--outline'}`}
              >
                {plan.featured ? 'Get Total Protection' : `Choose ${plan.name.split(' ').pop()}`}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
